"use client";

import React from "react";
import { useTranslations } from "@/lib/i18n-client";
import { Reveal, Stagger, StaggerItem } from "@/components/shared/motion";
import { Zap, Plane, Phone, Headset } from "lucide-react";

/** Compact airport-reassurance band, just below the hero. */
export default function TrustStrip() {
  const { t } = useTranslations();
  const items = [
    { icon: Zap, label: t("sky.trust.instant", "Instant email delivery") },
    { icon: Plane, label: t("sky.trust.land", "Works the moment you land") },
    { icon: Phone, label: t("sky.trust.number", "Keep your home number") },
    { icon: Headset, label: t("sky.trust.support", "24/7 traveler support") },
  ];

  return (
    <section className="container mx-auto px-4 -mt-6">
      <Reveal as="div" y={14} className="rounded-2xl border border-border bg-card shadow-sm px-6 py-4">
        <Stagger as="div" staggerChildren={0.05} className="grid grid-cols-2 md:grid-cols-4 gap-y-3 gap-x-4">
          {items.map(({ icon: Icon, label }, i) => (
            <StaggerItem key={i} as="div" y={8} className="inline-flex items-center gap-2 text-sm font-medium text-foreground/85">
              <span className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-primary/10 text-primary shrink-0">
                <Icon className="w-4 h-4" />
              </span>
              {label}
            </StaggerItem>
          ))}
        </Stagger>
      </Reveal>
    </section>
  );
}
